'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var React = require('react');
var revalidateEvents = require('./events.js');
var lite = require('dequal/lite');
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n.default = e;
    return n;
}
var React__default = /*#__PURE__*/ _interopDefault(React);
var revalidateEvents__namespace = /*#__PURE__*/ _interopNamespace(revalidateEvents);
// Global state used to deduplicate requests and store listeners
var SWRGlobalState = new WeakMap();
// Shared state between server components and client components
var noop = function() {};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = /*#__NOINLINE__*/ noop();
var OBJECT = Object;
var isUndefined = function(v) {
    return v === UNDEFINED;
};
var isFunction = function(v) {
    return typeof v == 'function';
};
var mergeObjects = function(a, b) {
    return _object_spread({}, a, b);
};
var isPromiseLike = function(x) {
    return isFunction(x.then);
};
var EMPTY_CACHE = {};
var INITIAL_CACHE = {};
var STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var isWindowDefined = (typeof window === "undefined" ? "undefined" : _type_of(window)) != STR_UNDEFINED;
var isDocumentDefined = (typeof document === "undefined" ? "undefined" : _type_of(document)) != STR_UNDEFINED;
var isLegacyDeno = isWindowDefined && 'Deno' in window;
var hasRequestAnimationFrame = function() {
    return isWindowDefined && _type_of(window['requestAnimationFrame']) != STR_UNDEFINED;
};
var createCacheHelper = function(cache, key) {
    var state = SWRGlobalState.get(cache);
    return [
        // Getter
        function() {
            return !isUndefined(key) && cache.get(key) || EMPTY_CACHE;
        },
        // Setter
        function(info) {
            if (!isUndefined(key)) {
                var prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in INITIAL_CACHE)) {
                    INITIAL_CACHE[key] = prev;
                }
                state[5](key, mergeObjects(prev, info), prev || EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        function() {
            if (!isUndefined(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in INITIAL_CACHE) return INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !isUndefined(key) && cache.get(key) || EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ var online = true;
var isOnline = function() {
    return online;
};
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var _ref = _sliced_to_array(isWindowDefined && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    noop,
    noop
], 2), onWindowEvent = _ref[0], offWindowEvent = _ref[1];
var isVisible = function() {
    var visibilityState = isDocumentDefined && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
var initFocus = function(callback) {
    // focus revalidate
    if (isDocumentDefined) {
        document.addEventListener('visibilitychange', callback);
    }
    onWindowEvent('focus', callback);
    return function() {
        if (isDocumentDefined) {
            document.removeEventListener('visibilitychange', callback);
        }
        offWindowEvent('focus', callback);
    };
};
var initReconnect = function(callback) {
    // revalidate on reconnected
    var onOnline = function() {
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function() {
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return function() {
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
var preset = {
    isOnline: isOnline,
    isVisible: isVisible
};
var defaultConfigOptions = {
    initFocus: initFocus,
    initReconnect: initReconnect
};
var IS_REACT_LEGACY = !React__default.default.useId;
var IS_SERVER = !isWindowDefined || isLegacyDeno;
// Polyfill requestAnimationFrame
var rAF = function(f) {
    return hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? React.useEffect : React.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
var navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var slowConnection = !IS_SERVER && navigatorConnection && ([
    'slow-2g',
    '2g'
].includes(navigatorConnection.effectiveType) || navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
var getTypeName = function(value) {
    return OBJECT.prototype.toString.call(value);
};
var isObjectTypeName = function(typeName, type) {
    return typeName === "[object ".concat(type, "]");
};
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
var stableHash = function(arg) {
    var type = typeof arg === "undefined" ? "undefined" : _type_of(arg);
    var typeName = getTypeName(arg);
    var isDate = isObjectTypeName(typeName, 'Date');
    var isRegex = isObjectTypeName(typeName, 'RegExp');
    var isPlainObject = isObjectTypeName(typeName, 'Object');
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++){
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while(!isUndefined(index = keys.pop())){
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    } else {
        result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    }
    return result;
};
var serialize = function(key) {
    if (isFunction(key)) {
        try {
            key = key();
        } catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    var args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? stableHash(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
var __timestamp = 0;
var getTimestamp = function() {
    return ++__timestamp;
};
function internalMutate() {
    return _internalMutate.apply(this, arguments);
}
function _internalMutate() {
    _internalMutate = _async_to_generator(function() {
        var _len, args, _key, _args, cache, _key1, _data, _opts, options, populateCache, rollbackOnErrorOption, optimisticData, rollbackOnError, throwOnError, keyFilter, matchedKeys, it, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;
        var _arguments = arguments;
        function mutateByKey(_k) {
            return _mutateByKey.apply(this, arguments);
        }
        function _mutateByKey() {
            _mutateByKey = _async_to_generator(function(_k) {
                var _serialize, key, _createCacheHelper, get, set, _SWRGlobalState_get, EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD, startRevalidate, data, error, isError, beforeMutationTs, hasOptimisticData, state, displayedData, currentData, committedData, populateCachedData;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // Serialize key
                            _serialize = _sliced_to_array(serialize(_k), 1), key = _serialize[0];
                            if (!key) return [
                                2
                            ];
                            _createCacheHelper = _sliced_to_array(createCacheHelper(cache, key), 2), get = _createCacheHelper[0], set = _createCacheHelper[1];
                            _SWRGlobalState_get = _sliced_to_array(SWRGlobalState.get(cache), 4), EVENT_REVALIDATORS = _SWRGlobalState_get[0], MUTATION = _SWRGlobalState_get[1], FETCH = _SWRGlobalState_get[2], PRELOAD = _SWRGlobalState_get[3];
                            startRevalidate = function() {
                                var revalidators = EVENT_REVALIDATORS[key];
                                var revalidate = isFunction(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
                                if (revalidate) {
                                    // Invalidate the key by deleting the concurrent request markers so new
                                    // requests will not be deduped.
                                    delete FETCH[key];
                                    delete PRELOAD[key];
                                    if (revalidators && revalidators[0]) {
                                        return revalidators[0](revalidateEvents__namespace.MUTATE_EVENT).then(function() {
                                            return get().data;
                                        });
                                    }
                                }
                                return get().data;
                            };
                            // If there is no new data provided, revalidate the key with current state.
                            if (args.length < 3) {
                                // Revalidate and broadcast state.
                                return [
                                    2,
                                    startRevalidate()
                                ];
                            }
                            data = _data;
                            isError = false;
                            // Update global timestamps.
                            beforeMutationTs = getTimestamp();
                            MUTATION[key] = [
                                beforeMutationTs,
                                0
                            ];
                            hasOptimisticData = !isUndefined(optimisticData);
                            state = get();
                            // `displayedData` is the current value on screen. It could be the optimistic value
                            // that is going to be overridden by a `committedData`, or get reverted back.
                            // `committedData` is the validated value that comes from a fetch or mutation.
                            displayedData = state.data;
                            currentData = state._c;
                            committedData = isUndefined(currentData) ? displayedData : currentData;
                            // Do optimistic data update.
                            if (hasOptimisticData) {
                                optimisticData = isFunction(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
                                // When we set optimistic data, backup the current committedData data in `_c`.
                                set({
                                    data: optimisticData,
                                    _c: committedData
                                });
                            }
                            if (isFunction(data)) {
                                // `data` is a function, call it passing current cache value.
                                try {
                                    data = data(committedData);
                                } catch (err) {
                                    // If it throws an error synchronously, we shouldn't update the cache.
                                    error = err;
                                    isError = true;
                                }
                            }
                            if (!(data && isPromiseLike(data))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                data.catch(function(err) {
                                    error = err;
                                    isError = true;
                                })
                            ];
                        case 1:
                            // This means that the mutation is async, we need to check timestamps to
                            // avoid race conditions.
                            data = _state.sent();
                            // Check if other mutations have occurred since we've started this mutation.
                            // If there's a race we don't update cache or broadcast the change,
                            // just return the data.
                            if (beforeMutationTs !== MUTATION[key][0]) {
                                if (isError) throw error;
                                return [
                                    2,
                                    data
                                ];
                            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                                // Rollback. Always populate the cache in this case but without
                                // transforming the data.
                                populateCache = true;
                                // Reset data to be the latest committed data, and clear the `_c` value.
                                set({
                                    data: committedData,
                                    _c: UNDEFINED
                                });
                            }
                            _state.label = 2;
                        case 2:
                            // If we should write back the cache after request.
                            if (populateCache) {
                                if (!isError) {
                                    // Transform the result into data.
                                    if (isFunction(populateCache)) {
                                        populateCachedData = populateCache(data, committedData);
                                        set({
                                            data: populateCachedData,
                                            error: UNDEFINED,
                                            _c: UNDEFINED
                                        });
                                    } else {
                                        // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                                        set({
                                            data: data,
                                            error: UNDEFINED,
                                            _c: UNDEFINED
                                        });
                                    }
                                }
                            }
                            // Reset the timestamp to mark the mutation has ended.
                            MUTATION[key][1] = getTimestamp();
                            // Update existing SWR Hooks' internal states:
                            Promise.resolve(startRevalidate()).then(function() {
                                // The mutation and revalidation are ended, we can clear it since the data is
                                // not an optimistic value anymore.
                                set({
                                    _c: UNDEFINED
                                });
                            });
                            // Throw error or return data
                            if (isError) {
                                if (throwOnError) throw error;
                                return [
                                    2
                                ];
                            }
                            return [
                                2,
                                data
                            ];
                    }
                });
            });
            return _mutateByKey.apply(this, arguments);
        }
        return _ts_generator(this, function(_state) {
            for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = _arguments[_key];
            }
            _args = _sliced_to_array(args, 4), cache = _args[0], _key1 = _args[1], _data = _args[2], _opts = _args[3];
            // When passing as a boolean, it's explicitly used to disable/enable
            // revalidation.
            options = mergeObjects({
                populateCache: true,
                throwOnError: true
            }, typeof _opts === 'boolean' ? {
                revalidate: _opts
            } : _opts || {});
            populateCache = options.populateCache;
            rollbackOnErrorOption = options.rollbackOnError;
            optimisticData = options.optimisticData;
            rollbackOnError = function(error) {
                return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
            };
            throwOnError = options.throwOnError;
            // If the second argument is a key filter, return the mutation results for all
            // filtered keys.
            if (isFunction(_key1)) {
                keyFilter = _key1;
                matchedKeys = [];
                it = cache.keys();
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(_iterator = it[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        key = _step.value;
                        if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) {
                            matchedKeys.push(key);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    2,
                    Promise.all(matchedKeys.map(mutateByKey))
                ];
            }
            return [
                2,
                mutateByKey(_key1)
            ];
        });
    });
    return _internalMutate.apply(this, arguments);
}
var revalidateAllKeys = function(revalidators, type) {
    for(var key in revalidators){
        if (revalidators[key][0]) revalidators[key][0](type);
    }
};
var initCache = function(provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        var opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = Object.create(null);
        var mutate = internalMutate.bind(UNDEFINED, provider);
        var unmount = noop;
        var subscriptions = Object.create(null);
        var subscribe = function(key, callback) {
            var subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return function() {
                return subs.splice(subs.indexOf(callback), 1);
            };
        };
        var setter = function(key, value, prev) {
            provider.set(key, value);
            var subs = subscriptions[key];
            if (subs) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = subs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fn = _step.value;
                        fn(value, prev);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        };
        var initProvider = function() {
            if (!SWRGlobalState.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                SWRGlobalState.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!IS_SERVER) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    var releaseFocus = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, revalidateEvents__namespace.FOCUS_EVENT)));
                    var releaseReconnect = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, revalidateEvents__namespace.RECONNECT_EVENT)));
                    unmount = function() {
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        SWRGlobalState.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        SWRGlobalState.get(provider)[4]
    ];
};
// error retry
var onErrorRetry = function(_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
var compare = lite.dequal;
// Default cache provider
var _initCache = _sliced_to_array(initCache(new Map()), 2), cache = _initCache[0], mutate = _initCache[1];
// Default config
var defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry: onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare: compare,
    isPaused: function() {
        return false;
    },
    cache: cache,
    mutate: mutate,
    fallback: {}
}, preset);
var mergeConfigs = function(a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};
var SWRConfigContext = React.createContext({});
var SWRConfig = function(props) {
    var value = props.value;
    var parentConfig = React.useContext(SWRConfigContext);
    var isFunctionalConfig = isFunction(value);
    var config = React.useMemo(function() {
        return isFunctionalConfig ? value(parentConfig) : value;
    }, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    var extendedConfig = React.useMemo(function() {
        return isFunctionalConfig ? config : mergeConfigs(parentConfig, config);
    }, [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    var provider = config && config.provider;
    // initialize the cache only on first access.
    var cacheContextRef = React.useRef(UNDEFINED);
    if (provider && !cacheContextRef.current) {
        cacheContextRef.current = initCache(provider(extendedConfig.cache || cache), config);
    }
    var cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(function() {
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return React.createElement(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};
exports.IS_REACT_LEGACY = IS_REACT_LEGACY;
exports.IS_SERVER = IS_SERVER;
exports.OBJECT = OBJECT;
exports.SWRConfig = SWRConfig;
exports.SWRConfigContext = SWRConfigContext;
exports.SWRGlobalState = SWRGlobalState;
exports.UNDEFINED = UNDEFINED;
exports.cache = cache;
exports.compare = compare;
exports.createCacheHelper = createCacheHelper;
exports.defaultConfig = defaultConfig;
exports.defaultConfigOptions = defaultConfigOptions;
exports.getTimestamp = getTimestamp;
exports.hasRequestAnimationFrame = hasRequestAnimationFrame;
exports.initCache = initCache;
exports.internalMutate = internalMutate;
exports.isDocumentDefined = isDocumentDefined;
exports.isFunction = isFunction;
exports.isLegacyDeno = isLegacyDeno;
exports.isPromiseLike = isPromiseLike;
exports.isUndefined = isUndefined;
exports.isWindowDefined = isWindowDefined;
exports.mergeConfigs = mergeConfigs;
exports.mergeObjects = mergeObjects;
exports.mutate = mutate;
exports.noop = noop;
exports.preset = preset;
exports.rAF = rAF;
exports.serialize = serialize;
exports.slowConnection = slowConnection;
exports.stableHash = stableHash;
exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;
